var _path, _path2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSuccessList(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.73445 18.7323C7.48445 18.7323 7.24345 18.6383 7.05745 18.4683L4.61245 16.2183C4.20545 15.8443 4.17945 15.2113 4.55245 14.8053C4.92745 14.3983 5.56145 14.3733 5.96545 14.7463L7.58045 16.2313L11.5884 10.6393C11.9094 10.1913 12.5344 10.0863 12.9824 10.4093C13.4314 10.7303 13.5354 11.3553 13.2134 11.8033L8.54645 18.3153C8.38045 18.5473 8.12245 18.6983 7.83745 18.7273C7.80245 18.7303 7.76845 18.7323 7.73445 18.7323Z",
    fill: "#1080FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.9992 12.9014H16.0352C15.4822 12.9014 15.0352 12.4534 15.0352 11.9014C15.0352 11.3484 15.4822 10.9014 16.0352 10.9014H19.9992C20.5522 10.9014 20.9992 11.3484 20.9992 11.9014C20.9992 12.4534 20.5522 12.9014 19.9992 12.9014Z",
    fill: "#1080FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 7.21777H20C20.553 7.21777 21 6.77077 21 6.21777C21 5.66477 20.553 5.21777 20 5.21777H4C3.447 5.21777 3 5.66477 3 6.21777C3 6.77077 3.447 7.21777 4 7.21777Z",
    fill: "#1080FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5449 18.7783H20.0009C20.5539 18.7783 21.0009 18.3303 21.0009 17.7783C21.0009 17.2253 20.5539 16.7783 20.0009 16.7783H13.5449C12.9919 16.7783 12.5449 17.2253 12.5449 17.7783C12.5449 18.3303 12.9919 18.7783 13.5449 18.7783Z",
    fill: "#1080FF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessList);
export default __webpack_public_path__ + "static/media/Success_list.59caa08e1b4a488bc60e4e6f9555d5ba.svg";
export { ForwardRef as ReactComponent };